import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";

const testimonialData = [
    {
        image: 'testimonial-01',
        name: 'Mohamed Saibullah',
        designation: 'Ahamed Industries',
        location: 'Coimbatore,India', 
        description: "KR Power delivered exactly what we needed — quality products, on time, every time. Truly reliable service.",
       
    },
    {
        image: 'testimonial-02',
        name: 'Riyas Ahamed',
        designation: 'GreenVolt Solutions',
        location: 'Chennai,India', 
        description: "Their cable trays and solar structures are durable and well-engineered. Excellent support from start to finish.",
      
    },
    {
        image: 'testimonial-03',
        name: 'Karthik Raj',
        designation: 'TechLine Energy Pvt. Ltd.',
        location: 'Coimbatore,India', 
        description:'KR Power delivers quality products, reliable service, and smooth delivery. Highly recommended for their professionalism.'
    },
]


const TestimonialOne = ({column , teamStyle}) => {
    return (
        <div className="row row--15">
            {testimonialData.map((data, index) => (
                <div className={`${column}`} key={index}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`rn-box-card ${teamStyle}`}>
                            <div className="inner">
                                <figure className="thumbnail">
                                    <img src={`./images/testimonial/${data.image}.webp`} alt="Metal fabrication company Coimbatore" />
                                </figure>
                                <figcaption className="content">
                                    <p className="description">{data.description}</p>
                                    <h2 className="title">{data.name}</h2>
                                    <h6 className="subtitle theme-gradient">{data.designation}</h6>
                                </figcaption>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}

export default TestimonialOne;
